import { render, staticRenderFns } from "./VerticalBarChart.vue?vue&type=template&id=af0c2e4a&scoped=true"
import script from "./VerticalBarChart.vue?vue&type=script&lang=js"
export * from "./VerticalBarChart.vue?vue&type=script&lang=js"
import style0 from "./VerticalBarChart.vue?vue&type=style&index=0&id=af0c2e4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0c2e4a",
  null
  
)

export default component.exports